import React, { useState } from 'react';
import { Container, Grid } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import { Field } from '@progress/kendo-react-form';
import { Fragment } from 'react';
import { Label } from '@progress/kendo-react-labels';
import { TextArea } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';

import "./companyInfo.css";

function CompanyInfoPure(props) {
    const { t } = useTranslation();

    const [fieldsState, setFieldsState] = useState({
        numEmployees: '',
        numUsers: '',
        sectorEconomico: '',
        descripcionActividades: '',
        razonSocial: '',
        regimenFiscal: '',
        rfc: '',
        entidadFederativa: '',
        municipio: '',
        localidad: '',
        codigoPostal: '',
        colonia: '',
        calle: '',
        numeroExterior: '',
        numeroInterior: ''
    });

    const handleFieldChange = (field, value) => {
        setFieldsState(prevState => ({
            ...prevState,
            [field]: value
        }));
    };

    const employeesOptions = props.numEmployeesOptions.map((item) => { return item.name });
    const usersOptions = props.numUsersOptions.map((item) => { return item.name });
    const economicSectorOptions = props.economicSectorOptions.map((item) => { return item.name });

    return (
        <Fragment>
            <Container maxWidth="md">
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                        <div className='company-info-tooltip-movil'>
                            <Label className="company-info-form-labels">
                                {t('register.companyData.employeeNumbers')}
                            </Label>
                        </div>
                        <Field
                            name="numEmployees"
                            className='direction-input-data'

                            component={DropDownList}
                            data={employeesOptions}
                            required
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <span className='company-info-display-span'>{t('register.companyData.applicationUsersNumber')}</span>
                        <Field
                            name="numUsers"
                            className='direction-input-data'

                            component={DropDownList}
                            data={usersOptions}
                            required
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <div className='company-info-tooltip-movil'>
                            <Label className="company-info-form-labels">
                                {t('register.companyData.economicSector')}
                            </Label>
                        </div>
                        <Field
                            name="economicSector"
                            className='direction-input-data'
                            component={DropDownList}
                            data={economicSectorOptions}
                            required
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <span className='company-info-display-span'>{t('register.companyData.activityDescription')}</span>
                        <Field
                            name="activityDescription"
                            className='direction-input-data'

                            component={TextArea}

                        />

                    </Grid>
                </Grid>

                <div className="title-form-step">
                    <h3 className="company-info-title">
                        {t("register.companyData.billingDataTitle")}
                    </h3>
                </div>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <span className='company-info-display-span'>{t('register.invoiceData.businessName')}</span>
                        <Field
                            name="businessName"
                            className='direction-input-data'

                            component={props.validateInput}
                            editor={() => (
                                <TextArea
                                    value={fieldsState.razonSocial}
                                    onChange={(e) => handleFieldChange('razonSocial', e.value)}
                                    fullWidth
                                    maxLength={200}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <span className='company-info-display-span'>{t('register.invoiceData.taxRegime')}</span>
                        <Field
                            name="taxRegime"
                            className='direction-input-data'

                            component={props.validateInput}
                            editor={() => (
                                <TextArea
                                    value={fieldsState.regimenFiscal}
                                    onChange={(e) => handleFieldChange('regimenFiscal', e.value)}
                                    fullWidth
                                    maxLength={100}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <span className='company-info-display-span'>{t('register.invoiceData.rfc')}</span>
                        <Field
                            name="rfc"
                            className='direction-input-data'

                            component={props.validateInput}
                        />
                    </Grid>
                </Grid>
                <div className="title-form-step">
                    <h3 className="company-info-title">
                        {t("register.companyData.fiscalTitle")}
                    </h3>
                </div>                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                        <span className='company-info-display-span'>{t('register.fiscalData.federalEntity')}</span>
                        <Field
                            name="federalEntity"
                            className='direction-input-data'

                            component={props.validateInput}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <span className='company-info-display-span'>{t('register.fiscalData.municipality')}</span>
                        <Field
                            name="municipality"
                            component={props.validateInput}
                            className='direction-input-data'

                            editor={() => (
                                <TextArea
                                    value={fieldsState.municipio}
                                    onChange={(e) => handleFieldChange('municipio', e.value)}
                                    fullWidth
                                    maxLength={100}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <span className='company-info-display-span'>{t('register.fiscalData.location')}</span>
                        <Field
                            name="locality"
                            component={props.validateInput}
                            className='direction-input-data'

                            editor={() => (
                                <TextArea
                                    value={fieldsState.localidad}
                                    onChange={(e) => handleFieldChange('localidad', e.value)}
                                    fullWidth
                                    maxLength={100}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <span className='company-info-display-span'>{t('register.address.zipCode')}</span>
                        <Field
                            name="zipCode"
                            className='direction-input-data'

                            component={props.validateInput}
                            editor={() => (
                                <TextArea
                                    value={fieldsState.codigoPostal}
                                    onChange={(e) => handleFieldChange('codigoPostal', e.value)}
                                    fullWidth
                                    maxLength={8}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <span className='company-info-display-span'>{t('register.address.suburb')}</span>
                        <Field
                            name="colony"
                            className='direction-input-data'

                            component={props.validateInput}
                            editor={() => (
                                <TextArea
                                    value={fieldsState.colonia}
                                    onChange={(e) => handleFieldChange('colonia', e.value)}
                                    fullWidth
                                    maxLength={100}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <span className='company-info-display-span'>{t('register.fiscalData.street')}</span>
                        <Field
                            name="street"
                            className='direction-input-data'

                            component={props.validateInput}
                            editor={() => (
                                <TextArea
                                    value={fieldsState.calle}
                                    onChange={(e) => handleFieldChange('calle', e.value)}
                                    fullWidth
                                    maxLength={100}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <span className='company-info-display-span'>{t('register.fiscalData.externalNumber')}</span>
                        <Field
                            name="externalNumber"
                            className='direction-input-data'

                            component={props.validateInput}
                            editor={() => (
                                <TextArea
                                    value={fieldsState.numeroExterior}
                                    onChange={(e) => handleFieldChange('numeroExterior', e.value)}
                                    fullWidth
                                    maxLength={10}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <span className='company-info-display-span'>{t('register.fiscalData.internalNumber')}</span>
                        <Field
                            name="internalNumber"
                            className='direction-input-data'

                            component={props.validateInput}
                            editor={() => (
                                <TextArea
                                    value={fieldsState.numeroInterior}
                                    onChange={(e) => handleFieldChange('numeroInterior', e.value)}
                                    fullWidth
                                    maxLength={10}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
            </Container>
        </Fragment>
    );
}

export { CompanyInfoPure as default }

